var exports = {
  "kL": "x61f99309--7bd846--container",
  "Sl": "x61f99309--7bd846--image",
  "Qq": "x61f99309--7bd846--text",
};

module.exports = exports;
